import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { AuthStateService } from '../../services/authstate.service';

@Component({
  selector: 'app-admin-more-view',
  imports: [TranslocoDirective, RouterLink],
  templateUrl: './admin-more-view.component.html',
  styleUrl: './admin-more-view.component.scss'
})
export class AdminMoreViewComponent {

  constructor(
    private auth: AuthStateService
  ) { }

  structure = [
    {
      groupName: "fleetManagement", items: [
        { name: "bikes", link: "/admin/mapview/bikes", icon: "pedal_bike", color: "blue", authLevels: ["1", "2", "3", "4"] },
        { name: "stations", link: "/admin/mapview/stations", icon: "bike_dock", color: "purple", authLevels: ["1", "2", "3", "4"] },
        { name: "tasks", link: "/admin/tasks/manage", icon: "task", color: "orange", authLevels: ["1", "2", "3", "4"] },
        { name: "automations", link: "/admin/tasks/automations", icon: "bolt", color: "lime", authLevels: ["1", "2", "3"] },
      ]
    },
    {
      groupName: "masterData", items: [
        { name: "bikeModels", link: "/admin/models", icon: "quick_reference", color: "teal", authLevels: ["1", "2", "3"] },
        { name: "users", link: "/admin/users", icon: "group", color: "pink", authLevels: ["1"] },
        { name: "actions", link: "/admin/actions", icon: "play_arrow", color: "amber", authLevels: ["1", "2", "3"] },
        { name: "tariffPlans", link: "/admin/tariffPlans", icon: "payments", color: "velvet", authLevels: ["1", "2", "3"] },
      ]
    },
    {
      groupName: "monitoringAndAnalysis", items: [
        { name: "userReports", link: "/admin/userReports", icon: "flag", color: "orange", authLevels: ["1", "2", "3"] },
        { name: "reports", link: "/admin/reports", icon: "monitoring", color: "brown", authLevels: ["1", "2", "3"] },
        { name: "balance", link: "/admin/balancing/manage", icon: "hub", color: "sky", authLevels: ["1", "2", "3"] },
      ]
    },
    {
      groupName: "system", items: [
        { name: "admins", link: "/admin/admins", icon: "shield_person", color: "green", authLevels: ["1"] },
        { name: "settings", link: "/admin/settings", icon: "settings", color: "surface", authLevels: ["1", "2", "3", "4"] },
      ]
    }
  ]

  getAuthorizedItems(cat: any) {
    return cat.items.filter((item: any) => ((item.authLevels ?? []).includes(this.auth.loginData.user.authLevel)))
  }
}
